module.exports = __webpack_public_path__ + "img/btn_no_weapon_on.b213aeda.svg";